import app from '../app';
import './gallery-view';
import './share';
import './mini-about';
import './header';
import './sider-bar';
import './select';
import Toast from './toast';
import useSearch from './search';
import ListLoadMore from './listLoadMore';
import Countdown from './countdown';
import svg from './svg';

app.el.$body.append($(`<div style="display:none">${svg}</div>`));

if (!app.comp) {
  app.comp = {
    toast: new Toast(),
    useSearch,
    Fancybox,
    ListLoadMore,
    Countdown,
  };
}
